import React, { useEffect, useState, useRef } from "react";
import HTMLFlipBook from "react-pageflip";
import * as pdfjsLib from "pdfjs-dist/build/pdf";

const Brochure = () => {
  const [pages, setPages] = useState([]);
  const flipBookRef = useRef(null);
  const pdfUrl = "/sunrising-brochure.pdf"; // Ensure the file is in the public folder
  const pdfUrldl = "/sunrising-brochure_dl.pdf"; // Ensure the file is in the public folder

  useEffect(() => {
    const loadPdf = async () => {
      pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
      const loadingTask = pdfjsLib.getDocument(pdfUrl);
      const pdf = await loadingTask.promise;
      let pageImages = [];

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: context, viewport }).promise;

        pageImages.push(canvas.toDataURL("image/png"));
      }

      setPages(pageImages);
    };

    loadPdf();
  }, []);

  const handleNextPage = () => {
    if (flipBookRef.current) {
      flipBookRef.current.pageFlip().flipNext();
    }
  };

  const handlePrevPage = () => {
    if (flipBookRef.current) {
      flipBookRef.current.pageFlip().flipPrev();
    }
  };

  return (
    <div className="flex items-center justify-center">
      <div className="flex flex-col items-center justify-center min-h-screen p-4  h-[500px] w-[1500px] mb-40 mt-10 ">
        <h1 className="mb-4 text-3xl font-bold text-center">Our Brochure</h1>

        {pages.length > 0 ? (
          <>
            <div className="relative flex justify-center w-full">
              <HTMLFlipBook
                ref={flipBookRef}
                width={window.innerWidth > 768 ? 550 : 320}
                height={window.innerWidth > 768 ? 550 : 350}
                size="stretch"
                maxShadowOpacity={0.5}
                drawShadow
                className="border rounded-lg shadow-lg"
              >
                {/* Cover Page (Single Page) */}
                <div className="flex items-center justify-center p-2 bg-white rounded-lg">
                  <img
                    src={pages[0]}
                    alt="Cover Page"
                    className="w-full h-full"
                  />
                </div>

                {/* Content Pages */}
                {pages.slice(1).map((page, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-center p-1 bg-white rounded-lg"
                  >
                    <img
                      src={page}
                      alt={`Page ${index + 2}`}
                      className="w-full h-full"
                    />
                  </div>
                ))}
              </HTMLFlipBook>
            </div>

            {/* Buttons for navigation */}
            <div className="flex mt-4 space-x-4">
              <button
                onClick={handlePrevPage}
                className="px-4 py-2 text-white bg-gray-600 rounded-md shadow hover:bg-gray-700"
              >
                Previous
              </button>
              <button
                onClick={handleNextPage}
                className="px-4 py-2 text-white bg-gray-600 rounded-md shadow hover:bg-gray-700"
              >
                Next
              </button>
              <a
                href={pdfUrldl}
                download="sunrising-brochure.pdf"
                className="px-4 py-2 text-white bg-[#A14D1F] rounded-md shadow hover:bg-orange-600"
              >
                Download Brochure
              </a>
            </div>
          </>
        ) : (
          <span className="loading loading-dots loading-lg"></span>
        )}
      </div>
    </div>
  );
};

export default Brochure;
